import { createContext } from "react";

export const myContext = createContext();
export const Provider = myContext.Provider;
export const Consumer = myContext.Consumer;
